import { useEffect } from "react"

export default function UseAutoResize() {
  useEffect(() => {
    const PARENT_ORIGIN = "https://www.sigmachart.co.kr"
    const root = document.documentElement

    const post = () => {
      const body = document.body
      const html = document.documentElement

      // 가능한 모든 높이 중 최대값 사용
      const height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      )

      window.parent?.postMessage(
        { __fromReactApp: true, type: "height", height },
        PARENT_ORIGIN
      )
    }

    // 부모의 요청(ping)에 응답
    const onMessage = (e: MessageEvent) => {
      if (e.origin !== PARENT_ORIGIN) return
      const d = e.data || {}
      if (d.__fromParent && d.type === "height:request") {
        post()
      }
    }
    window.addEventListener("message", onMessage)

    // 초기 + 약간의 딜레이 보정
    post()
    const t1 = setTimeout(post, 150)
    const t2 = setTimeout(post, 400)

    // 내용 변화 감지
    const ro = new ResizeObserver(() => {
      post()
    })
    ro.observe(root)

    // 폰트/이미지 로딩 등
    const handleLoad = () => {
      post()
    }
    window.addEventListener("load", handleLoad)

    return () => {
      window.removeEventListener("message", onMessage)
      window.removeEventListener("load", handleLoad)
      ro.disconnect()
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [])

  return null
}
